<div class="container mx-auto px-4 py-8 max-w-4xl">
  <div class="bg-white shadow-md rounded-lg px-8 py-6">
    <h2 class="text-2xl font-semibold text-gray-800 mb-6 text-center  uppercase">Enviar datos de facturación de un
      proveedor</h2>
    <form [formGroup]="billingForm" (ngSubmit)="confirmSubmit()" class="space-y-6">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <!-- Selector de proveedor -->
        <div class="md:col-span-2 lg:col-span-1">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Proveedor</mat-label>
            <mat-select formControlName="providerId" placeholder="Selecciona un proveedor">
              <mat-option *ngFor="let provider of providers" [value]="provider.id">{{ provider.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Selectores de fecha con formato ajustado -->
        <div class="md:col-span-1 lg:col-span-1">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Fecha de inicio</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="startDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="md:col-span-1 lg:col-span-1">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Fecha de fin</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="endDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <!-- Opciones avanzadas -->
      <div *ngIf="showAdvancedOptions" class="px-2 mt-4">
        <h3 class="text-center text-gray-700 font-semibold">Opciones avanzadas</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Código del Cliente (opcional)</mat-label>
              <input matInput type="number" formControlName="clientCode" (input)="onClientCodeChange($event)">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>CIF (opcional)</mat-label>
              <input matInput formControlName="cif" (input)="onCifChange($event)">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="flex justify-center gap-2">
        <button type="submit" class="bg-orange-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-orange-700">Enviar
          Datos de Facturación</button>
        <button type="button" (click)="clearFilters()"
          class="bg-red-500 text-white font-bold py-3 px-6 rounded-lg hover:bg-red-700">Limpiar Filtros</button>
      </div>

      <!-- Toggle de opciones avanzadas -->
      <div class="text-center py-4">
        <button type="button" (click)="toggleAdvancedOptions()"
          class="bg-gray-200 text-gray-400 font-semibold py-2 px-4 rounded hover:bg-gray-300">
          {{ showAdvancedOptions ? 'Menos opciones' : 'Más filtros' }}
        </button>
      </div>
    </form>

    <!-- Indicador de carga -->
    <div *ngIf="isLoading" class="flex justify-center items-center mt-5">
      <mat-spinner class="text-orange-500 animate-spin" strokeWidth="3" [diameter]="70"></mat-spinner>
    </div>
  </div>
</div>